var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7C14.1569 7 15.5 5.65686 15.5 4C15.5 2.34315 14.1569 1 12.5 1C10.8432 1 9.5 2.34315 9.5 4C9.5 5.65686 10.8432 7 12.5 7Z",
    fill: "#176318"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2167 17.75H8.41624C7.60127 17.75 6.96094 16.9038 6.96094 15.8269V12.5192C6.96094 9.90385 8.64909 7.75 10.6865 7.75H14.0046C16.042 7.75 17.7302 9.90385 17.7302 12.5192V15.8269C17.672 16.9038 17.0316 17.75 16.2167 17.75Z",
    fill: "#176318"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18.8284 9 19.5 8.32843 19.5 7.5C19.5 6.67158 18.8284 6 18 6C17.1716 6 16.5 6.67158 16.5 7.5C16.5 8.32843 17.1716 9 18 9Z",
    fill: "#176318"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7707 16.5H20.0888C20.6127 16.5 20.962 15.9729 20.962 15.2952V13.1867C20.962 11.5301 19.9724 10.25 18.6917 10.25H16.6543",
    fill: "#176318"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderPeople);
export default __webpack_public_path__ + "static/media/HeaderPeople.ce325054ec936b5ec6ea3f60b2def6b4.svg";
export { ForwardRef as ReactComponent };